export const supportEdnaRedirectPath = 'support-edna-redirect'
